import React from "react";
import { UseFormReturn } from "react-hook-form";
import { CalculatorFormProps } from "./PricingCalculator";

const setLeftPosition = (min: number, max: number, value: number) => {
    const newValue = Number(((value - min) * 100) / (max - min));
    const newPosition = 10 - newValue * 0.2;
    return `calc(${newValue}% + (${newPosition}px))`;
};
const leftPositionStyle = (value: number) => {
    return setLeftPosition(0, 10000, value);
};

const indicatorValue = [
    {
        value: 0,
        label: "0",
        leftPosition: "0.9%",
    },
    {
        value: 2500,
        label: "2.5k",
        leftPosition: leftPositionStyle(2500),
    },
    {
        value: 5000,
        label: "5k",
        leftPosition: leftPositionStyle(5000),
    },
    {
        value: 7500,
        label: "7.5k",
        leftPosition: leftPositionStyle(7500),
    },
    {
        value: 10000,
        label: "10k",
        leftPosition: "99.2%",
    },
];

interface PricingIndicatorProps {
    handleClick: (value: number) => void;
    register: UseFormReturn<CalculatorFormProps>["register"];
    watch: UseFormReturn<CalculatorFormProps>["watch"];
    name: keyof Omit<CalculatorFormProps, "countryName" | "planType">;
}

const PricingIndicator: React.FC<PricingIndicatorProps> = (props) => {
    const { handleClick, name, register, watch } = props;
    return (
        <div className="relative mt-3">
            <div className="range-value absolute" style={{ left: leftPositionStyle(watch(name) as number), top: "-75%" }}>
                <div
                    className="absolute left-1/2 px-1 py-0 border-blue-500 border-solid bg-white rounded-3xl"
                    style={{ minWidth: "50px", borderWidth: "0.5px", transform: "translate(-50%, 0)" }}
                >
                    <p className="text-center text-blue-400 font-medium" style={{ fontSize: "12px" }}>
                        {watch(name)}
                    </p>
                </div>
            </div>
            <input className="w-full h-1 cursor-pointer" type="range" id="convo" min="0" max="10000" step="100" {...register(name)} />
            {indicatorValue.map((item, index) => (
                <React.Fragment key={index}>
                    <div onClick={() => handleClick(item.value)}>
                        <div
                            className="border-solid border-blue-400 rounded-full bg-white cursor-pointer"
                            style={{ borderWidth: "2px", width: "8px", height: "8px", top: "11px", position: "absolute", left: item.leftPosition, transform: "translateX(-50%)" }}
                        />
                        <div className="text-xs cursor-pointer" style={{ top: "30px", position: "absolute", left: item.leftPosition, transform: "translateX(-50%)" }}>
                            {item.label}
                        </div>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
};

export default PricingIndicator;
